/**
 * Authoritative list of predefined tags organised by group.
 *
 * Kept in sync with byte-pantry-recipe-service/src/constants/tags.ts.
 * The LLM selects tags from this controlled vocabulary only.
 */

export interface TagGroup {
  name: string;
  tags: readonly string[];
}

export const PREDEFINED_TAG_GROUPS: readonly TagGroup[] = [
  {
    name: 'Cuisine',
    tags: [
      'Italian',
      'Indian',
      'Mexican',
      'British',
      'Chinese',
      'Middle Eastern',
      'Thai',
      'Japanese',
      'Korean',
      'Greek',
      'French',
      'American',
      'Caribbean',
      'African',
      'Fusion',
    ],
  },
  {
    name: 'Diet',
    tags: [
      'Vegetarian',
      'Vegan',
      'Keto',
      'Paleo',
      'Gluten-Free',
      'Dairy-Free',
      'Nut-Free',
      'Low-Carb',
      'High-Protein',
      'Halal',
      'Kosher',
      'Low-Sodium',
    ],
  },
  {
    name: 'Meal',
    tags: [
      'Breakfast',
      'Brunch',
      'Lunch',
      'Dinner',
      'Snack',
      'Dessert',
      'Appetiser',
      'Side Dish',
      'Main Course',
      'Light Meal',
      'Street Food',
    ],
  },
  {
    name: 'Occasion',
    tags: [
      'Christmas',
      'Birthday',
      'Weeknight',
      'BBQ',
      'Easter',
      'Picnic',
      'Potluck',
      'Party Food',
      'Date Night',
      "Kids' Favourite",
      'Meal Prep',
      'Comfort Food',
      'Budget-Friendly',
    ],
  },
  {
    name: 'Difficulty',
    tags: ['Easy', 'Medium', 'Hard'],
  },
  {
    name: 'Method',
    tags: [
      'Oven',
      'Stovetop',
      'Grill/BBQ',
      'Air Fryer',
      'Microwave',
      'Slow Cooker',
      'Instant Pot',
      'No-Cook',
    ],
  },
  {
    name: 'Season',
    tags: ['Spring', 'Summer', 'Autumn', 'Winter'],
  },
] as const;

/** Flat array of every predefined tag. */
export const PREDEFINED_TAGS: readonly string[] = PREDEFINED_TAG_GROUPS.flatMap(
  (group) => group.tags
);

/**
 * Tag groups excluded from the browse/filter UI.
 * These groups (Occasion, Method, Season) are too broad for quick filtering
 * and clutter the chip rail — they remain available when editing a recipe.
 */
export const FILTER_EXCLUDED_TAG_GROUPS: readonly string[] = ['Occasion', 'Method', 'Season'];
